// extracted by mini-css-extract-plugin
export default {"title":"Products_title__St8ab","description":"Products_description__g3o4A"};